import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  title: {
    id: 'LumaBot.CardLumaBotFlow.title',
    defaultMessage: 'LumaBot Flow Session',
  },
  completedOn: {
    id: 'LumaBot.CardLumaBotFlow.completedOn',
    defaultMessage: 'Completed on {completedTimestamp}',
  },
  tooltip: {
    id: 'LumaBot.CardLumaBotFlow.tooltip',
    defaultMessage: 'Click to open session dialog',
  },
});
